import { css } from '@emotion/core';
import { Theme } from './theme';

export const globalStyles = (theme: Theme) => css`
  html,
  body {
    margin: 0;
    min-height: 100%;
    background-color: ${theme.colors.body};
    overflow: hidden;
  }

  #app {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .pa-ui-lib_sidebar-wrapper,
  .pa-ui-lib_second_sidebar-wrapper {
    height: calc(100vh - 62px) !important;
  }

  // end fix global styles

  .safari-fix-text-white {
    -webkit-text-fill-color: #fff;
  }

  .alert > svg > path:last-child {
    stroke: red;
    fill: red;
  }

  [class^='pa-uiLib-checkout-button'] {
    border: none;
    background: none;
  }
  [class^='pa-uiLib-main-button'] {
    border: none;
  }
  .grecaptcha-badge {
    right: -1000px !important;
  }
  button[aria-label="Close"]:hover > svg > path {
      color: #C209C1
    }
  }
`;
